module.exports = __webpack_public_path__ + "assets/img/block-hover-137327ff.png";